import { buildUrl } from 'cloudinary-build-url'
import { STORAGE_TYPES, RESIZE_TYPES, Gravity } from '@cld-apis/utils'

export const profileSize = (url: string, cloudName: string) => {
  if (!url) {
    return ''
  }

  return buildUrl(url, {
    cloud: {
      cloudName,
      storageType: STORAGE_TYPES.UPLOAD,
    },
    transformations: {
      resize: {
        type: RESIZE_TYPES.FILL,
        width: 500,
        height: 500,
      },
      gravity: Gravity.Subject,
    },
  })
}

export const cloudinaryBuildImageURL = (
  public_id: string | undefined,
  cloudName: string,
  width: number = 600,
  height: number = 300,
) => {
  if (!public_id) {
    return ''
  }

  return buildUrl(public_id, {
    cloud: {
      cloudName,
      storageType: STORAGE_TYPES.UPLOAD,
    },
    transformations: {
      resize: {
        type: RESIZE_TYPES.FILL,
        width,
        height,
      },
      gravity: Gravity.Subject,
    },
  })

}
